import React, { useState } from 'react';

const TestimonialsSection: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      text: "GutterBrush saved me thousands! No more expensive water damage repairs and I haven't climbed a ladder in 3 years. Best investment I've made for my home.",
      name: "Sarah Johnson",
      location: "Denver, CO",
      rating: 5
    },
    {
      text: "Installation was so easy - took me less than 2 hours for my whole house. Randy was incredibly helpful with sizing. Haven't cleaned gutters since 2019!",
      name: "Mike Rodriguez", 
      location: "Austin, TX",
      rating: 5
    },
    {
      text: "After flooding my basement twice from clogged gutters, I finally got GutterBrush. Three seasons later and zero problems. Wish I'd done this sooner.",
      name: "Jennifer Chen",
      location: "Portland, OR", 
      rating: 5
    },
    {
      text: "Professional grade quality at a fraction of the cost of other systems. Alex walked me through everything. My commercial property has been worry-free ever since.",
      name: "David Thompson",
      location: "Phoenix, AZ",
      rating: 5
    },
    {
      text: "The satellite measurement service was amazing - got an accurate quote without anyone coming to my house. Installation was exactly as described. Highly recommend!",
      name: "Lisa Martinez",
      location: "Tampa, FL",
      rating: 5
    },
    {
      text: "Made in USA quality shows. After 4 years, still working perfectly. No maintenance needed. Best $350 I ever spent on home improvement.",
      name: "Robert Wilson",
      location: "Nashville, TN",
      rating: 5
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">What Our Customers Say</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real reviews from homeowners who've experienced the GutterBrush difference. 
            Join thousands of satisfied customers protecting their homes.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-lg p-8 text-center">
            <div className="flex justify-center mb-4">
              {[...Array(testimonials[currentSlide].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
              ))}
            </div>
            
            <blockquote className="text-xl text-gray-700 mb-6 leading-relaxed italic">
              "{testimonials[currentSlide].text}"
            </blockquote>
            
            <div className="font-bold text-gray-800 text-lg">
              {testimonials[currentSlide].name}
            </div>
            <div className="text-gray-600">
              {testimonials[currentSlide].location}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-shadow"
          >
            <i className="ri-arrow-left-line text-gray-800 text-xl"></i>
          </button>
          
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-shadow"
          >
            <i className="ri-arrow-right-line text-gray-800 text-xl"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  index === currentSlide ? 'bg-orange-500' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Review Badges */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-16">
          <div className="text-center">
            <div className="bg-blue-600 text-white rounded-lg p-4 mb-2">
              <i className="ri-google-fill text-2xl"></i>
            </div>
            <div className="flex justify-center mb-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400"></i>
              ))}
            </div>
            <div className="text-sm text-gray-600">4.8/5 - 247 reviews</div>
          </div>
          
          <div className="text-center">
            <div className="bg-orange-500 text-white rounded-lg p-4 mb-2">
              <i className="ri-home-line text-2xl"></i>
            </div>
            <div className="flex justify-center mb-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400"></i>
              ))}
            </div>
            <div className="text-sm text-gray-600">4.9/5 - HomeAdvisor</div>
          </div>
          
          <div className="text-center">
            <div className="bg-red-600 text-white rounded-lg p-4 mb-2">
              <i className="ri-yelp-fill text-2xl"></i>
            </div>
            <div className="flex justify-center mb-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400"></i>
              ))}
            </div>
            <div className="text-sm text-gray-600">4.7/5 - 89 reviews</div>
          </div>
          
          <div className="text-center">
            <div className="bg-blue-800 text-white rounded-lg p-4 mb-2">
              <i className="ri-facebook-fill text-2xl"></i>
            </div>
            <div className="flex justify-center mb-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400"></i>
              ))}
            </div>
            <div className="text-sm text-gray-600">4.8/5 - 156 reviews</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
